module.exports = __webpack_public_path__ + "static/media/Group 16.8af20947.png";